import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import PgrConfidenceTierService from "@app/shared/confidence-tier/pgrConfidenceTierService";
import { PgrConfidenceTierDefinition } from "@app/shared/confidence-tier/pgrConfidenceTierDefinition";

interface UseConfidenceTierDefinitionsResult {
  /** Highest confidence first; null until loaded or on failure. */
  definitions: PgrConfidenceTierDefinition[] | null;
  isError: boolean;
  isPending: boolean;
}

export const CONFIDENCE_TIER_DEFINITIONS_QUERY_KEY = ["pgr-confidence-tier-definitions"];

/** Shared by every badge, bar and filter; fetched once per page. */
export function useConfidenceTierDefinitions(): UseConfidenceTierDefinitionsResult {
  const [service] = useState(() => new PgrConfidenceTierService());

  const { data, isError, isPending } = useQuery({
    queryFn: ({ signal }) => service.getConfidenceTierDefinitions(signal),
    queryKey: CONFIDENCE_TIER_DEFINITIONS_QUERY_KEY,
    staleTime: 5 * 60 * 1000,
  });

  return {
    definitions: data ?? null,
    isError,
    isPending,
  };
}
